function FadeUpdatedRow(row_id, text) {
    parcelUpdated = false;
    var row = $('#results tr td input[type="hidden"][value=' + row_id + ']').closest('tr');
    var cont = row.html();
    row.html('<td colspan="9" style="color:red">  Parcel ' + text + '.</td>').fadeIn(300, function () {
        var e = this;
        setTimeout(function () { row.html(cont); SelectableRow(); }, 1500);
    });
}
var badPassword;
$(function () {
    $.ajaxSetup({ cache: false });
    $('.datepicker').datepicker();
    $('#btnSubmit').off('click').on('click', function (e) {
        $('#hidNumRec').val($('#txtNumOfRec').val());
    });
    $('#invoiceBut').off('click').on('click', function (e) {
        if (sel_row_id > 0) {
            window.location.assign(url_Invoice + '/' + sel_row_id);
        }
    });
    /*background color for date picker start*/
    $("#txtp_datefrom").mouseover(function () {
        $(this).css("background-color", "#D3D3D3");
    }).mouseout(function () {
        $(this).css("background-color", "#FFFFFF");
    });
    $("#txtp_dateto").mouseover(function () {
        $(this).css("background-color", "#D3D3D3");
    }).mouseout(function () {
        $(this).css("background-color", "#FFFFFF");
    });
    $("#txtr_datefrom").mouseover(function () {
        $(this).css("background-color", "#D3D3D3");
    }).mouseout(function () {
        $(this).css("background-color", "#FFFFFF");
    });
    $("#txtr_dateto").mouseover(function () {
        $(this).css("background-color", "#D3D3D3");
    }).mouseout(function () {
        $(this).css("background-color", "#FFFFFF");
    });
    /*background color for date picker end*/
    /*
    $("#btnSubmit").mouseover(function () {
        $(this).css("background-color", "#B90700");
    }).mouseout(function () {
        $(this).css("background-color", "#CC0000");
    });
   
    $("#newParcelBut").mouseover(function () {
        $(this).css("background-color", "#B90700");
    }).mouseout(function () {
        $(this).css("background-color", "#CC0000");
    });
    
    $("#invoiceBut").mouseover(function () {
        $(this).css("background-color", "#B90700");
    }).mouseout(function () {
        $(this).css("background-color", "#CC0000");
    });

    $("#cn23But").mouseover(function () {
        $(this).css("background-color", "#B90700");
    }).mouseout(function () {
        $(this).css("background-color", "#CC0000");
    });
    */
    $('#addParcel').dialog({
        height: 'auto',
        width: '1000px',
        minHeight: 600,
        //position: { my: "center center", at: "center-2 center-5", of: window },
        position: [($(window).width() / 2) - (890 / 2) - 30, 80],
        modal: true,
        resizable: false,
        autoOpen: false,
        open: function (event, ui) { $(".ui-dialog-titlebar-close", ui.dialog | ui).hide(); }
        //open: function (event, ui) {
        // Enable validation for unobtrusive stuffs
        //     $(this).load(options.url, function () {
        //         var $jQval = $.validator;
        //         $jQval.unobtrusive.parse($(this));
        //     });
        // }
    });
    $('#delete-dialog').dialog({
        autoOpen: false,
        modal: true,
        left: 0,
        width: 'auto',
        height: 'auto',
        minHeight: 140
    });
    $('#payment-dialog').dialog({
        autoOpen: false,
        modal: true,
        left: 0,
        width: 'auto',
        height: 'auto',
        minHeight: 140
    });
    $('#message-dialog').dialog({
        autoOpen: false,
        modal: true,
        width: 580,
        resizable: false,
        minHeight: 140
    });
    $('#signature-dialog').dialog({
        autoOpen: false,
        modal: true,
        width: 1200,
        resizable: false,
        height: 'auto',
        open: function (event, ui) { $(".ui-dialog-titlebar-close", ui.dialog | ui).hide(); }
    });
    $('#newParcelBut').off('click').on('click', function (e) {
        NewParcelButtonClick();
    });
});
function HandleSignature() {
    $('[id^=ParcelSignature]').off('click').on('click', function (e) {
        var id = this.id.split('_')[1];
        $("#signature-dialog").dialog('option', 'title', 'Signature is mandatory');
        $("#signature-dialog").dialog('open');
        // Initialize jSignature
        var $sigdiv = $("#signature").jSignature({ 'UndoButton': false });
        $("#signature").jSignature('reset');
        $("#clickSignature").attr("disabled", true);
        $("#signature").bind('change', function (e) {
            $("#clickSignature").attr("disabled", false);
        });
        $('#clickSignature').off('click').on('click', function (e) {
            $("#signature").unbind('change');
            // Get response of type image
            var data = $sigdiv.jSignature('getData', 'default');
            $("#signature-dialog").dialog('close');
            $("#signature").empty();
            var func = 'if (Signature_Add_' + id + ') Signature_Add_' + id + '(data)';
            eval(func);
        });
        $('#clearSignature').off('click').on('click', function (e) {
            $("#signature").jSignature('reset');
        });
        $('#cancelSignature').off('click').on('click', function (e) {
            $("#signature").unbind('change');
            $("#signature-dialog").dialog('close');
            $("#signature").empty();
        });
        return false;
    });
}
function NewParcelButtonClick() {
    var url = $("#warning-hazmat img")[0].src;
    var p = url.indexOf('/Images/');
    url = url.substr(0, p);
    $("#warning-hazmat img")[0].src = (Domain === 'Payment' ? url + '/Images/money_with_text.png' : url + '/Images/prohib.png');
    $("#warning-hazmat").dialog('open');
}
function OpenNewParcelDialog() {
    var title = "New " + Domain;
    $("#addParcel").dialog('option', 'title', title);
    $.ajax({
        type: "POST",
        url: url_Insert,
        data: { PID: 'I' },
        // dataType: "json",
        success: function (data) {
            $("#addParcel").html(data);
            $.validator.unobtrusive.parse($("#addParcel"));
            $("#addParcel").dialog('open');
        }
    });
}
var sel_row_id = 0;
var sel_item_id = 0;
var parcelUpdated = false;
function FilterComplete(result) {
    if (typeof result === 'string') {
        $('#errorMessage').text('');
        $('#grid').html(result);
        SelectableRow();
    }
    else
        $('#errorMessage').text(result[1]);
}
function SelectCurrentRow(row_id) {
    if (sel_row_id == row_id)
        return;
    $('#results tr td input[type="hidden"][value=' + row_id + ']').closest('tr').addClass("selectedRowStyle");
    if (sel_row_id > 0)
        $('#results tr td input[type="hidden"][value=' + sel_row_id + ']').closest('tr').removeClass("selectedRowStyle");
    sel_row_id = row_id;
}
function SelectFirstRow() {
    var row = $("#results table tbody").children('tr:first');
    if (row) {
        var oldsel = sel_row_id;
        sel_row_id = row.find("input[type=hidden]").attr("value");
        if (oldsel > 0)
            $('#results tr td input[type="hidden"][value=' + oldsel + ']').closest('tr').removeClass("selectedRowStyle");
        row.addClass("selectedRowStyle");
    }
}
function SelectableRow() {
    setArrows();
    SelectFirstRow();
    $('#results tr').off('click').on('click', function (e) {
        if ($(this).parent().is("thead"))
            return;
        var row_id = $(this).find("input[type=hidden]").attr("value");
        if (sel_row_id > 0)
            $('#results tr td input[type="hidden"][value=' + sel_row_id + ']').closest('tr').removeClass("selectedRowStyle");
        $(this).addClass("selectedRowStyle");
        sel_row_id = row_id;
    });
    $('#results tr td a').off('click').on('click', function (e) {
        var title;
        var link = $(this); //for future use
        var row_id = $(this).closest('tr').find("input[type=hidden]").attr("value");
        if (link.text() == "D") {
            var sel = $(this).closest('tr').find('td');
            $('#delete-dialog').text('Are you sure you want to delete parcel ' + sel.eq(3).text() + '?');
            $('#delete-dialog').append('<br/><span id="deleteResult" class="field-validation-error" />');
            $('#delete-dialog').dialog('option', 'title', 'Confirm');
            var buttons = {
                "OK": function () {
                    $.post(Url_delete + "?id=" + row_id, function (data) {
                        if (!data) {
                            $('#delete-dialog').dialog("close");
                            link.parent().parent().html('<td colspan="9" style="color:red">  ' + Domain + ' deleted.</td>').fadeIn(300, function () {
                                var e = this;
                                setTimeout(function () { $(e).fadeOut(400); link.closest("tr").hide('fast'); if (sel_row_id == row_id)
                                    SelectFirstRow(); }, 1500);
                            });
                        }
                        else {
                            $('#deleteResult').text(data);
                        }
                    });
                },
                "Cancel": function () {
                    $(this).dialog("close");
                }
            };
            $('#delete-dialog').dialog("option", "buttons", buttons);
            $('#delete-dialog').dialog('open');
        }
        else if (link.text() == "P") {
            SelectCurrentRow(row_id);
            paymentFunc(row_id);
        }
        else if (link.text() == "L") {
            SelectCurrentRow(row_id);
            window.open(url_View.replace('ViewParcel', 'PrintLabelx4x6') + '/' + row_id, target = '_blank');
        }
        else if (link.text() == "+") { // || link.attr("class") == 'declaration') {
            SelectCurrentRow(row_id);
            if (Domain === 'Parcel')
                title = "Details (Declaration#: " + $(this).closest('tr').find('td:first-child + td + td + td').text() + ")";
            else
                title = "Details (Item#: " + $(this).closest('tr').find('td:first-child + td + td + td input').val() + ")";
            $("#addParcel").dialog('option', 'title', title);
            //$('#addParcel').dialog('option', 'height', 560);
            $.ajax({
                type: "POST",
                url: url_View,
                data: { PID: 'V', id: row_id },
                // dataType: "json",
                success: function (data) {
                    $("#addParcel").html(data);
                    $("#addParcel").dialog('open');
                }
            });
        }
        else if (link.text().substr(0, 1) == "M") {
            SelectCurrentRow(row_id);
            title = "Record #" + row_id;
            $("#message-dialog").dialog('option', 'title', title);
            //$('#message-dialog').dialog('option', 'height', 320);
            $.ajax({
                type: "POST",
                url: url_Messages,
                data: { id: row_id, message_type: Message_Type },
                // dataType: "json",
                success: function (data) {
                    $("#message-dialog").html(data);
                    $("#message-dialog").dialog('open');
                }
            });
        }
        //return false; // prevents the default behaviour
    });
    $('#status').change(function () {
        $("#btnSubmit").trigger('click');
    });
    $('#message-dialog').on('dialogclose', function (event) {
        if (parcelUpdated)
            $("#btnSubmit").trigger('click');
    });
}
function SelectDeviveryRow() {
    setTimeout(function () {
        var row = $("#deliveryGrid table tbody").children('tr:first');
        if (row)
            DeviveryRowClicked(row);
        InitDelivery();
    }, 250);
}
function ValidatePassword(password) {
    var rules = [{
            Pattern: "[A-Z]",
            Target: "UpperCase"
        },
        {
            Pattern: "[a-z]",
            Target: "LowerCase"
        },
        {
            Pattern: "[0-9]",
            Target: "Numbers"
        },
        {
            Pattern: "[!@@#$%^&*]",
            Target: "Symbols"
        }
    ];
    //var password = $(this).val();
    $("#Length").removeClass(password.length > 7 ? "glyphicon-remove" : "glyphicon-ok");
    $("#Length").addClass(password.length > 7 ? "glyphicon-ok" : "glyphicon-remove");
    for (var i = 0; i < rules.length; i++) {
        $("#" + rules[i].Target).removeClass(new RegExp(rules[i].Pattern).test(password) ? "glyphicon-remove" : "glyphicon-ok");
        $("#" + rules[i].Target).addClass(new RegExp(rules[i].Pattern).test(password) ? "glyphicon-ok" : "glyphicon-remove");
    }
}
function CheckPasswordStrength(obj) {
    var password = obj.value;
    ValidatePassword(password);
    return;
    /*
        var length = password.length;
        var colour = "";
        var text = "";
    
        badPassword = true;
        var score = 0;
        //if password bigger than 4 give 1 point
        if (password.length > 7) score++;
        //if password has both lower and uppercase characters give 1 point
        if ((password.match(/[a-z]/)) && (password.match(/[A-Z]/))) score++;
        //if password has at least one number give 1 point
        if (password.match(/\d+/)) score++;
        //if password has at least one special characther give 1 point
        if (password.match(/.[!,@@,#,$,%,^,&,*,>,<,\.,\+,?,_,~,\-,=,(,)[\]:{}]/)) score++;
        //if password bigger than 7 give another 1 point
        if (password.length < 13) score++;
    
        if (score <= 2) {
            colour = "red";
            text = "Password strength is low";
        }
        else if (score <= 4) {
            colour = "orange";
            text = "Password strength is moderate";
        }
        else {
            colour = "green";
            text = "";
            badPassword = false;
        }
        if (!badPassword)
            ComparePasswords($('#ConfirmPassword').get(0));
    
        $("#Password").css("background-color", colour);
        $("#PasswordMessage").text(text);
    */
}
function ComparePasswords(obj) {
    if (typeof obj == "undefined")
        return;
    var password = $("#Password").val();
    var confirm = obj.value;
    var colour = "";
    var text = "";
    if (password != confirm) {
        colour = "red";
        text = "Passwords do not match";
        badPassword = true;
    }
    else {
        colour = "green";
        text = "";
        badPassword = false;
    }
    $("#ConfirmPassword").css("background-color", colour);
    $("#PasswordMessage").text(text);
}
//# sourceMappingURL=MeestFunctions.js.map